export default __webpack_public_path__ + "static/media/head04_th_pc.59d464b5.png";